/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface IsothermFillMode {
}

export enum IsothermFillMode_Enum {
  kInvalid = 0,
  kBlendedColor = 1,
  kPalette = 2,
  UNRECOGNIZED = -1,
}

export function isothermFillMode_EnumFromJSON(object: any): IsothermFillMode_Enum {
  switch (object) {
    case 0:
    case "kInvalid":
      return IsothermFillMode_Enum.kInvalid;
    case 1:
    case "kBlendedColor":
      return IsothermFillMode_Enum.kBlendedColor;
    case 2:
    case "kPalette":
      return IsothermFillMode_Enum.kPalette;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IsothermFillMode_Enum.UNRECOGNIZED;
  }
}

export function isothermFillMode_EnumToJSON(object: IsothermFillMode_Enum): string {
  switch (object) {
    case IsothermFillMode_Enum.kInvalid:
      return "kInvalid";
    case IsothermFillMode_Enum.kBlendedColor:
      return "kBlendedColor";
    case IsothermFillMode_Enum.kPalette:
      return "kPalette";
    case IsothermFillMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIsothermFillMode(): IsothermFillMode {
  return {};
}

export const IsothermFillMode = {
  encode(_: IsothermFillMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IsothermFillMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIsothermFillMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): IsothermFillMode {
    return {};
  },

  toJSON(_: IsothermFillMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<IsothermFillMode>, I>>(base?: I): IsothermFillMode {
    return IsothermFillMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IsothermFillMode>, I>>(_: I): IsothermFillMode {
    const message = createBaseIsothermFillMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
